/**
 * @file Tag.tsx
 * @author markJia(markjia@tencent.com)
 */
import { ViewTag } from '../../views/ViewTag';
export var Tag = ViewTag;